import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

const slides = [
  {
    id: 1,
    img: "https://www.kaybees.com.pk/_next/image?url=https%3A%2F%2Fassets.indolj.io%2Fimages%2F1682093085-1677843262-lkjhgfd.jpeg&w=1920&q=75"
  },
  {
    id: 2,
    img: "https://www.kaybees.com.pk/_next/image?url=https%3A%2F%2Fassets.indolj.io%2Fimages%2F1683198594-hbanner.jpg&w=1920&q=75"
  },
  {
    id: 3,
    img: "https://www.kaybees.com.pk/_next/image?url=https%3A%2F%2Fassets.indolj.io%2Fimages%2F1679165983-i.jpg&w=1920&q=75"
  },
];

const MyCarousel = () => {
  return (
    <Carousel autoPlay infiniteLoop interval={3000} showThumbs={false} showStatus={false} showArrows={false} dynamicHeight={100}>
      {slides.map(slide => (
        <div key={slide.id}>
          <img src={slide.img} alt="" />
        </div>
      ))}
    </Carousel>
  );
};

export default MyCarousel;
